import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_currencies_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: {  }): 
  Promise<{ result: { Id?: number, DecimalPrecisionFactor?: number, Label?: string, ShortLabel?: string }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = null;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, DecimalPrecisionFactor?: number, Label?: string, ShortLabel?: string }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { $keys: number[] }): 
  Promise<{ result: { Id?: number, DecimalPrecisionFactor?: number, Label?: string, ShortLabel?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      }) {
      return false;
    }
}
